import type { NavigationItem, NavigationGroup } from "@/types";
import { cloneDeep } from "@apollo/client/utilities";

export const filterNavigationItems = (userPrivileges: string[], nav: NavigationItem[]): NavigationItem[] => {
  // Convert array to string for faster lookup
  const privileges = userPrivileges.join(':')

  // Build a new nav that has been filtered
  return nav.reduce((navItems: NavigationItem[], option: NavigationItem): NavigationItem[] => {

    // Determine if there are privileges we must check against
    if (option.privileges.length) {
      const hasPrivilege = option.privileges.some(privilege => {
        return privileges.includes(privilege)
      })
      // Do not render nav item if the User does not have the required privilege
      if (!hasPrivilege) return navItems
    }

    // Prep an updated option object as nested values may need to be mutated
    const updatedOption = {
      ...cloneDeep(option)
    }

    // Filter groups and their children
    if (option.groups) {
      updatedOption.groups = option.groups.reduce((groups, group) => {
        const filteredChildren = filterNavigationItems(userPrivileges, group.children)

        // filter the group out if there are no children
        if (!filteredChildren.length) return groups

        groups.push({
          ...cloneDeep(group),
          children: filteredChildren
        })

        return groups

      }, [] as NavigationGroup[])
    }

    navItems.push(updatedOption)
    return navItems

  }, [])
}
